import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import ByTheNumbers from './components/ByTheNumbers';
import WhyDeerPoint from './components/WhyDeerPoint';
import SafetyCommitment from './components/SafetyCommitment';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AboutHero />
      <OurStory />
      <ByTheNumbers />
      <WhyDeerPoint />
      <SafetyCommitment />
      <AboutCTA />
      <Footer />
    </div>
  );
}